<div class="page-container ">
  <div class="header-section">
    <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
    <h2 class="page-title">{{ judgeLabel }} Reassignment</h2>
  </div>

  <div class="content-wrapper" [class.blur]="loading">

    <form [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()"
      class="bg-fieldset p-4 rounded-lg shadow-sm border border-gray-200">

      <div class="search-grid">

        <app-case-number-search [label]="userType === 'lawyer' ? 'Case Number' : 'Appeal Number'"
          (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
        </app-case-number-search>


        <div class="form-actions"> <button type="reset" mat-stroked-button color="primary" class="h-10 w-full md:w-auto"
            (click)="resetHandler()">
            Reset
          </button>
          <button type="submit" mat-flat-button color="primary" class="h-10 w-full md:w-auto">
            Search
          </button>
        </div>

      </div>
    </form>

    <!-- Justice Reassignment Section -->

    <!-- Justice Reassignment Information -->
    <div class="justice-reassignment-card" *ngIf="casePhaseData != null">

      <div class="justice-reassignment-header">
        <mat-icon>gavel</mat-icon>
        <span>{{ judgeLabel }} Reassignment</span>
      </div>

      <div class="justice-reassignment-body">
        <div class="case-info-item">
          <span class="case-info-label">
            {{ userType === 'lawyer' ? 'Case Number' : 'Appeal Number' }}
          </span>
          <span class="case-info-value">
            {{ casePhaseData.courtCaseNumber || '-' }}
          </span>
        </div>

        <div class="case-info-divider"></div>

        <div class="case-info-item">
          <span class="case-info-label">Hearing Date</span>
          <span class="case-info-value">
            {{ casePhaseData.hearingDate || '-' }}
          </span>
        </div>

        <div class="case-info-divider"></div>

        <div class="case-info-item">
          <span class="case-info-label">Panel</span>
          <span class="case-info-value">
            {{ casePhaseData.panelName || '-' }}
          </span>
        </div>
      </div>

    </div>

    <!-- Dual Listbox Section -->
    <div class="dual-listbox-section" *ngIf="casePhaseData!=null">

      <div class="section-container">
        <div class="section-header interactive-header">
          <div class="instruction-wrapper">
            <mat-icon color="primary" class="info-icon">info</mat-icon>
            <span class="instruction-text">Drag and drop to move {{ judgeLabel.toLowerCase() }}s between Available and
              Panel lists.</span>
          </div>

          <div class="action-toolbar">
            <div class="save-action animated-action" [class.disabled]="!hasChanges"
              (click)="hasChanges && saveAssignment()">
              <mat-icon>save</mat-icon>
              <span>Save</span>
            </div>
          </div>
        </div>
      </div>

      <div class="dual-listbox-container">

        <!-- Available Judges List -->
        <div class="listbox-panel">
          <div class="panel-header"
            style="display: flex; justify-content: space-between; align-items: center; padding: 6px 16px;">
            <span>Available {{ judgeLabel }}s for this Appeal</span>
            <input type="text" [placeholder]="'Search ' + judgeLabel.toLowerCase() + 's...'"
              style="border-radius: 4px; border: none; padding: 4px 8px; font-size: 0.85rem; color: #333; width: 140px;"
              [formControl]="searchAvailableJudgesCtrl">
          </div>
          <div cdkDropList id="availableList" #availableList="cdkDropList" [cdkDropListData]="filteredAvailableJudges"
            [cdkDropListConnectedTo]="[panelList]" class="judge-list" (cdkDropListDropped)="drop($event)">

            <div class="judge-list-header">
              <span>{{ judgeLabel }} Name</span>
              <span>{{ judgeLabel }} ID</span>
            </div>

            <div class="judge-box box-state" *ngFor="let item of filteredAvailableJudges" cdkDrag>
              <span>{{ item.justiceName || '-' }}</span>
              <span>{{ item.justiceId }}</span>
            </div>

            <div class="no-data-msg" *ngIf="filteredAvailableJudges.length === 0">
              No available {{ judgeLabel.toLowerCase() }}s found
            </div>

          </div>
        </div>

        <!-- Panel Judges List -->
        <div class="listbox-panel">
          <div class="panel-header">Assigned {{ judgeLabel }}s for this Appeal</div>
          <div cdkDropList id="panelList" #panelList="cdkDropList" [cdkDropListData]="assignedJudges"
            [cdkDropListConnectedTo]="[availableList]" class="judge-list" (cdkDropListDropped)="drop($event)">

            <div class="judge-list-header">
              <span>{{ judgeLabel }} Name</span>
              <span>{{ judgeLabel }} ID</span>
            </div>

            <div class="judge-box" *ngFor="let item of assignedJudges" cdkDrag>
              <span>{{ item.justiceName || '-' }}</span>
              <span>{{ item.justiceId }}</span>
            </div>

            <div class="no-data-msg" *ngIf="assignedJudges.length === 0">
              No assigned {{ judgeLabel.toLowerCase() }}s for this appeal
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>